import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadListFailure,
  loadListSuccess,
  loadPortfolioManagerWithTeamsList,
  toggleLoadingStatus,
} from './portfolio-managers.actions';
import { selectPortfolioManagersLoading, selectPortfolioManagersWithTeamsList } from './portfolio-managers.selectors';

@Injectable()
export class UIEffect {
  private readonly action = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(ReferenceService);

  constructor() {}

  loadPortfolioManagerWithTeamsList = createEffect(() =>
    this.action.pipe(
      ofType(loadPortfolioManagerWithTeamsList),
      withLatestFrom(
        this.store.select(selectPortfolioManagersWithTeamsList),
        this.store.select(selectPortfolioManagersLoading),
      ),
      filter(([action, state, status]) => !state?.length && !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap((action) =>
        this.service.referenceLookupGetPortfolioManagersWithCustomTeamsGet().pipe(
          switchMap((response) => of(loadListSuccess({ payload: response.result }))),
          catchError((error) => of(loadListFailure({ error }))),
        ),
      ),
    ),
  );
}
